/* Industrial redesign (2026-10-26): pause factory clips when off-screen or when the visitor prefers reduced motion. */
(function () {
  var vids = document.querySelectorAll('video[data-dw-video]');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  vids.forEach(function (v) {
    v.muted = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.2 }).observe(v);
    }
  });
})();
